// extracted by mini-css-extract-plugin
export default {"chipLabel":"FlowNode_chipLabel__3DRBu","chipRootProject":"FlowNode_chipRootProject__2GpaU"};